import { sendApiRequest } from './apiConfig';
import { CheckoutResponse, PaymentResponse, PlanResponse, SimpleStringResponse } from '../dto/ResDtoRepository';
import { CreatePollReq } from '../dto/ReqDtoRepository';

export const getProduct = async (aui: string): Promise<PaymentResponse> => {
  return sendApiRequest<PaymentResponse>('get', `/api/v1/payment/product?aui=${aui}`);
};

export const getCurrentPlan = async (aui: string): Promise<PlanResponse> => {
  return sendApiRequest<PlanResponse>('get', `/api/v1/payment/plan?aui=${aui}`);
};

export const createCheckout = async (aui: string): Promise<CheckoutResponse> => {
  return sendApiRequest<CheckoutResponse>('get', `/api/v1/payment/checkout?aui=${aui}`);
};

export const getCustomerPortalUrl = async (aui: string): Promise<SimpleStringResponse> => {
  return sendApiRequest<SimpleStringResponse>('get', `/api/v1/payment/customer?aui=${aui}`);
};

export const requestAccess = async (aui: string): Promise<SimpleStringResponse> => {
  return sendApiRequest<SimpleStringResponse>('post', `/api/v1/payment/wait?aui=${aui}`);
};

export const submitPoll = async (aui: string, data: CreatePollReq): Promise<SimpleStringResponse> => {
  return sendApiRequest<SimpleStringResponse>('post', `/api/v1/payment/poll?aui=${aui}`, data);
};